import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

const Portal = (props: any) => {
  const { children, rootId = "forPortal", renderOnDidMount } = props;
  const mount = useRef<Element | null>(
    renderOnDidMount || __SERVER__ ? null : (document.getElementById(rootId) as Element),
  );
  const [didMount, setDidmount] = useState(false);

  useEffect(() => {
    if (renderOnDidMount && __CLIENT__) {
      mount.current = document.getElementById(rootId) as Element;
      if (!didMount) setDidmount(true);
    }
  }, []);

  if (mount.current) return createPortal(children, mount.current);
  return <></>;
};

Portal.defaultProps = {
  renderOnDidMount: false,
};

export default Portal;
